<div class="callback-wrapper">
  <div class="status-box" [ngClass]="{ success: success() === true, error: success() === false }">
    @if(loading()){
      <ng-container>
        <p class="loading">{{ 'ConfirmMail_Loading' | translate }}</p>
      </ng-container>
    }
    @if(!loading() && success() === true){
      <ng-container>
        <h1>{{ 'ConfirmMail_Success_Title' | translate }}</h1>
        <p>{{ 'ConfirmMail_Success_Message' | translate }}</p>
        @if(webDomain()){
          <div class="domain">
            <a [href]="webDomain()" rel="noopener" class="visit-link">
              {{ 'ConfirmMail_GoToDomain' | translate }}
            </a>
          </div>
        }

      </ng-container>
    }
    @if(!loading() && success() === false){
      <ng-container>
        <h1>{{ 'ConfirmMail_Error_Title' | translate }}</h1>
        <p>{{ 'ConfirmMail_Error_Message' | translate }}</p>
        @if (errorMessage()) {
          <p class="error-detail">{{ errorMessage() }}</p>
        }
      </ng-container>
    }

  </div>
</div>